<a
    class="resource-search-card selenium-resource-search-card {{ gtmPrefix }}"
    [attr.data-gtmlabel]="learningObject.title"
    [routerLink]="learningObject.routerLink"
    [attr.data-gtmresultindex]="gtmDataCardNumber"
>
    <app-language-badge [languages]="learningObject.languages"></app-language-badge>
    <div class="thumbnail">
        <app-resource-card-poster
            [posterImage]="learningObject.getPosterImage(180, 110)"
            [alt]="learningObject.getPosterImageAlt()"
            [duration]="learningObject.duration"
            [gtmPrefix]="gtmPrefix"
            [mediaType]="learningObject.mediaType[0]"
            [absoluteUrl]="learningObject.canonicalUrl"
            [gtmDataCardNumber]="gtmDataCardNumber"
        >
        </app-resource-card-poster>
    </div>
    <div class="content selenium-result-content">
        <a
            [class]="getResourceBodyClass()"
            [attr.data-gtmlabel]="learningObject.canonicalUrl"
            [attr.data-gtmresultindex]="gtmDataCardNumber"
        >
            <app-card-title><span [innerHtml]="learningObject.title"></span></app-card-title>
        </a>
        <app-card-description
            ><span [innerHtml]="learningObject.description | safeTruncate: 130"></span
        ></app-card-description>
        <app-search-card-meta
            [gradesDisplay]="learningObject.gradesDisplay"
            [contentProject]="learningObject.project"
            [supportMaterialsCount]="learningObject.supportMaterials.length"
            [supportMaterialsLink]="learningObject.routerLink"
            [brand]="learningObject.brand"
            [gtmDataCardNumber]="gtmDataCardNumber"
            [gtmPrefix]="gtmPrefix"
        >
        </app-search-card-meta>
    </div>
</a>
